import { Container, dispatcher, ingenuity, ITween, Meter, SpineBase, Sprite } from "@quest/base-core";
import { FreeGameView } from "@quest/slot-core";
import { gameConstants } from "../Constants/gameConstants";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { GameParserModel } from "../Platform/GameParserModel";
import { Linear } from "@quest/pixi-bridge";

export class FGQLinePlayerMsgController {
  protected view: FreeGameView;
  protected qLinesPlayerMessageContainer: Container;
  protected playerMsgBaseSpine: SpineBase;
  protected playerMsgSymbolCount: Meter;
  protected playerMsgSymbolContainer: Container;
  protected playerMsgContainer: Container;
  protected playerMsgWinMeter: Meter;
  protected playerMsgPaysText: Sprite;
  protected symbolId: number;
  protected symbolCount: number;
  protected winAmount: number;
  private hidePayerMsgTween: ITween
  private showPlayerMsgTween: ITween
  protected playerMsgSymbol: string = gameConstants.PLAYER_MESSAGE_SYMBOL_STRING;

  constructor(view: any) {
    this.view = view;
    this.init();
  }

  protected init(): void {
    this.initializeElements();
    this.subscribeEvents();
  }

  protected initializeElements(): void {
    this.qLinesPlayerMessageContainer = this.view.getContainerByID("qLinesPlayerMessageContainer");
    this.playerMsgBaseSpine = this.view.getSpineById("playerMessageBase");
    this.playerMsgContainer = this.view.getContainerByID("playerMsgContainer");
    this.playerMsgSymbolCount = this.view.getMeterById("playerMsgSymbolCount") as Meter;
    this.playerMsgSymbolContainer = this.view.getContainerByID("playerMsgSymbolContainer");
    this.playerMsgWinMeter = this.view.getMeterById("playerMsgWinMeter") as Meter;
  }

  protected subscribeEvents(): void {
    dispatcher.on(eventDispatchers.FG_SHOW_QLINE_PLAYER_MSG, this.onFGShowQlinePlayerMsg, this);
    dispatcher.on(eventDispatchers.FG_HIDE_QLINE_PLAYER_MSG, this.onFGHideQlinePlayerMsg, this);
  }
  // Event handler to show the player message when the relevant event is triggered

  protected onFGShowQlinePlayerMsg(): void {
    ingenuity.currentGame.tweens.remove(this.hidePayerMsgTween)
    ingenuity.currentGame.tweens.remove(this.showPlayerMsgTween)
    this.hidePlayerMsg();
    this.setPlayerMsgValues();
    this.addContainerToTop();
    this.showPlayerMsgBase();
    this.setPlayerMsg();
    this.showPlayerMsg();
  }
  // Ensures the message container is on top of the display hierarchy

  protected addContainerToTop(): void {
    this.view.addChild(this.qLinesPlayerMessageContainer);
  }
  // Displays the base animation and loops it after the intro

  protected showPlayerMsgBase(): void {
    this.qLinesPlayerMessageContainer.visible = true;
    this.playerMsgBaseSpine.visible = true;
    this.playerMsgBaseSpine.playAnim("intro");
    this.playerMsgBaseSpine.onComplete.addOnce(() => {
      this.playerMsgBaseSpine.onComplete.dispose();
      this.playerMsgBaseSpine.playAnim("loop", true);
    });
  }
  // Retrieves and sets the values to be displayed in the message (symbol count, win amount, etc.)

  protected setPlayerMsgValues(): void {
    const winData = (ingenuity.parserModel as GameParserModel).getWinLinesData()[
      (ingenuity.parserModel as GameParserModel).getWinLinesData().length -
      (ingenuity.parserModel as GameParserModel).getCascadeLineToggleCount()
    ];
    this.symbolCount = winData.winSymLen;
    this.winAmount = winData.win;
    if (winData.no === 200) {
      this.symbolId = 8;
    } else if (winData.no === 300) {
      this.symbolId = 9;
    } else {
      this.symbolId = winData.no;
    }
  }

  protected setPlayerMsg(): void {
    this.playerMsgSymbolCount.setValue(this.symbolCount);
    this.playerMsgWinMeter.setCurrencyFormattedValue((this.winAmount).toString());
  }
  // Makes relevant UI elements visible and animates the message fade-in
  protected showPlayerMsg(): void {
    this.playerMsgSymbolCount.visible = true;
    this.playerMsgSymbolContainer.visible = true;
    this.playerMsgSymbolContainer.children[this.symbolId].visible = true;
    this.playerMsgContainer.getChildByName("playerMsgPaysText").visible = true;
    this.playerMsgWinMeter.visible = true;
    this.setAlignment();
    this.qLinesPlayerMessageContainer.alpha = 0
    this.showPlayerMsgTween = ingenuity.currentGame.add
      .tween(this.qLinesPlayerMessageContainer)
      .to({ alpha: 1 }, 500, Linear.None, true, 0, 0, false);
    this.showPlayerMsgTween.onComplete.addOnce(() => {
      this.showPlayerMsgTween.stop();
      ingenuity.currentGame.tweens.remove(this.showPlayerMsgTween);
    }, this);
  }
  // Aligns the container and meter visuals horizontally centered
  protected setAlignment(): void {
    this.playerMsgContainer.setPivot(this.playerMsgContainer.width / 2, 0);
    this.playerMsgSymbolCount.setPivot(this.playerMsgSymbolCount.width / 2, 0);
  }
  // Event handler to hide the player message when the relevant event is triggered
  protected onFGHideQlinePlayerMsg(): void {
    ingenuity.currentGame.tweens.remove(this.showPlayerMsgTween)
    ingenuity.currentGame.tweens.remove(this.hidePayerMsgTween)
    this.hidePlayerMsgBase();
  }
  // Fades out the message and then hides the UI elements after the animation
  protected hidePlayerMsgBase(): void {
    this.hidePayerMsgTween = ingenuity.currentGame.add
      .tween(this.qLinesPlayerMessageContainer)
      .to({ alpha: 0 }, 200, Linear.None, true, 0, 0, false);
    this.hidePayerMsgTween.onComplete.addOnce(() => {
      this.hidePayerMsgTween.stop();
      ingenuity.currentGame.tweens.remove(this.hidePayerMsgTween);
      this.hidePlayerMsg();
    }, this);
  }
  // Hides all message-related UI elements and resets visibility
  protected hidePlayerMsg(): void {
    this.playerMsgBaseSpine.visible = false;
    this.qLinesPlayerMessageContainer.visible = false;
    this.playerMsgSymbolCount.visible = false;
    this.playerMsgSymbolContainer.visible = false;
    this.playerMsgSymbolContainer.children[this.symbolId] && (this.playerMsgSymbolContainer.children[this.symbolId].visible = false);
    this.playerMsgContainer.getChildByName("playerMsgPaysText").visible = false;
    this.playerMsgWinMeter.visible = false;
  }
}
